export const EventbookingCommentActionTypes = {
    API_RESPONSE_SUCCESS: '@@eventbooking_comment/API_RESPONSE_SUCCESS',
    API_RESPONSE_ERROR: '@@eventbooking_comment/API_RESPONSE_ERROR',

    LIST_EVENTBOOKING_COMMENT: '@@eventbooking_comment/LIST_EVENTBOOKING_COMMENT',
    UPDATE_EVENTBOOKING_COMMENT: '@@eventbooking_comment/UPDATE_EVENTBOOKING_COMMENT',
    CREATE_EVENTBOOKING_COMMENT: '@@eventbooking_comment/CREATE_EVENTBOOKING_COMMENT',
    UPDATE_MESSAGE_EVENTBOOKING_COMMENT: '@@eventbooking_comment/UPDATE_MESSAGE_EVENTBOOKING_COMMENT',
    DELETE_EVENTBOOKING_COMMENT: '@@eventbooking_comment/DELETE_EVENTBOOKING_COMMENT',
};